import type { IconData } from '@stacksjs/iconify-core'

export const direction: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M2 4v4h12.98l2.853-1.714a.333.333 0 0 0 0-.572L14.98 4zm8-2h4.98a2 2 0 0 1 1.03.286L18.863 4a2.333 2.333 0 0 1 0 4L16.01 9.714a2 2 0 0 1-1.03.286H10v9a1 1 0 0 1-2 0v-9H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h6V1a1 1 0 1 1 2 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default direction
